module.exports = __webpack_public_path__ + "media/images/icons/v-arrow-2b508cb7d9cb4ce94feb016f99452481.svg";